/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
import {
  Button,
  Chip,
  DialogActions,
  DialogContent,
  Grid,
  TextField,
  Typography,
  useTheme,
} from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import _ from "lodash";
import React, { useEffect, useState } from "react";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";

import { CustomTheme, Theme } from "../../../../types/customTheme";
import TextfieldDefault from "../../../../components/textField/TextfieldDefault";
import { INTEGER_NUMBER_PATTERN } from "../../../../utils/consts";
import ValidationMessage from "../../../../components/validation/ValidationMessage";
import ButtonCommon from "../../../../components/buttons/ButtonCommon";
import { Autocomplete } from "@material-ui/lab";
import DialogCommonDefault from "../../../../components/dialogs/DialogCommonDefault";
import { useForm } from "react-hook-form";
import PointsModalContent from "./ProductsModal/ProductsModalContent";
import CardCommon from "../../../../components/card/CardCommon";
import ProductModal from "./ProductsModal";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    textField: {
      overflowWrap: "break-word",
      wordWrap: "break-word",
    },
    base: {
      padding: "12px 12px 0 12px",
      [theme.breakpoints.up("sm")]: {
        padding: "16px 16px 0 16px",
      },
      borderRadius: 4,
    },
    error: {
      backgroundColor: theme.palette.error.dark,
      borderRadius: "8px 8px 0 0",
      border: `1px solid ${theme.palette.background.entity_border}`,
      padding: 8,
    },
    actionsWrapper: {
      padding: "16px 16px",
      display: "flex",
      justifyContent: "center",
    },
    autoComplete: {
      marginTop: "4px",
      "& .MuiAutocomplete-input": {
        color: theme.palette.custom.orange.contrastText,
      },
      "& .MuiInputBase-root": {
        color: "inherit",
        backgroundColor: theme.palette.background.entity_background,
        borderRadius: 10,
      },
      [`& fieldset`]: {
        borderRadius: 10,
        border: "none",
        color: theme.palette.custom.orange.contrastText,
      },
    },
    datePickerStyle: {
      [`& fieldset`]: {
        borderRadius: "10px",
        border: `1px solid ${theme.palette.background.entity_border}`,
        cursor: "pointer",
      },
      "& .MuiPickersClockPointer-pointer": {
        backgroundColor: `${theme.palette.background.default} !important`,
      },
      "& .MuiPickersClockNumber-clockNumberSelected": {
        backgroundColor: `${theme.palette.background.default} !important`,
      },
      "&:hover .MuiOutlinedInput-notchedOutline": {
        border: `1px solid ${theme.palette.background.entity_border}`,
      },
      "& .Mui-focused .MuiOutlinedInput-notchedOutline": {
        border: `1px solid ${theme.palette.background.entity_border}`,
      },
    },
    titleColor: {
      color: theme.palette.custom.orange.contrastText,
    },
  }),
);

interface FormData {
  name: string;
  requiredPick: string;
}

export interface DiscountInfoNodeProps {
  setGroupInfo: any;
  groupInfo: any;
  isMembersEmptyOrMinTwo: any;
  offerItemMap: any;
  setOfferItemMap: any;
  offerItemMapInitial: any;
  selectedWrapperIdListInitialNew: any;
  isActive: any;
  offerName: any;
}

/* Create, delete, and update discount information and users can view all discount information. */
const ThirdTypeGroup: React.FunctionComponent<DiscountInfoNodeProps> = ({
  setGroupInfo,
  groupInfo,
  isMembersEmptyOrMinTwo,
  offerItemMap,
  setOfferItemMap,
  offerItemMapInitial,
  selectedWrapperIdListInitialNew,
  isActive,
  offerName,
}) => {
  const [isOpenGroupsAddModal, setIsOpenGroupsAddModal] = React.useState(false);
  const [isOpenProductsAddModal, setIsOpenProductsAddModal] =
    React.useState(false);
  const [editableRewardId, setEditableRewardId] = useState<any>("");
  const [selectedWrapperIdList, setSelectedWrapperIdList] = useState<any>({});
  const [isMembersEmpty, setIsMembersEmpty] = useState(false);

  const { register, handleSubmit, errors, reset, formState, clearErrors } =
    useForm<FormData>({
      defaultValues: {
        name: "",
        requiredPick: "",
      },
    });

  const handleOpenProductsAddModal = () => {
    setIsOpenProductsAddModal(true);
  };

  const handleOpenGroupsAddModal = () => {
    setIsOpenGroupsAddModal(true);
    reset({
      name: "",
      requiredPick: "",
    });
    setSelectedWrapperIdList([]);
    setIsEdit(false);
  };

  const handleSubmitRewards = (
    selectedWrapperIdList: any,
    isEdit: any,
    rewardId: any,
  ) => {
    setSelectedWrapperIdList(selectedWrapperIdList);
    setIsMembersEmpty(false);
    setIsOpenProductsAddModal(false);
  };

  const handleSelectProduct = (
    event: Event,
    productWrapper: any,
    item: { id: string; name: string },
  ) => {
    const cloneSelectedWrapperIdList = { ...selectedWrapperIdList };
    // Step 1: Check and remove from undefined section if it exists
    if (cloneSelectedWrapperIdList.undefined?.[item.id]) {
      delete cloneSelectedWrapperIdList.undefined[item.id];

      if (Object.keys(cloneSelectedWrapperIdList.undefined).length === 0) {
        delete cloneSelectedWrapperIdList.undefined;
      }
      const output = Object.entries(offerItemMap).reduce(
        (acc: any, [key, value]: any) => {
          const newObj = { ...value };
 newObj.offerNameList = [...(value.offerNameList || [])];

          // if key equals selected id → increase activeCount by 1 (example logic)
          if (key === item.id) {
            if (isActive) {
              newObj.activeCount = (value.activeCount || 0) - 1;
            } else {
              newObj.deActiveCount = (value.deActiveCount || 0) - 1;
            }
            newObj.offerNameList = newObj.offerNameList.filter(
              (name: string) => name !== offerName,
            );
          }

          acc[key] = newObj;
          return acc;
        },
        {},
      );
      setOfferItemMap(output);
      // Stop here — do not add the item anywhere else
      setSelectedWrapperIdList(cloneSelectedWrapperIdList);
      return;
    }

    // Step 2: Toggle item in the actual productWrapper.id section
    if (cloneSelectedWrapperIdList[productWrapper.id]?.[item.id]) {
      delete cloneSelectedWrapperIdList[productWrapper.id][item.id];

      if (
        Object.keys(cloneSelectedWrapperIdList[productWrapper.id]).length === 0
      ) {
        const output = Object.entries(offerItemMap).reduce(
          (acc: any, [key, value]: any) => {
            const newObj = { ...value };
 newObj.offerNameList = [...(value.offerNameList || [])];

            // if key equals selected id → increase activeCount by 1 (example logic)
            if (key === item.id) {
              if (isActive) {
                newObj.activeCount = (value.activeCount || 0) - 1;
              } else {
                newObj.deActiveCount = (value.deActiveCount || 0) - 1;
              }
              newObj.offerNameList = newObj.offerNameList.filter(
                (name: string) => name !== offerName,
              );
            }

            acc[key] = newObj;
            return acc;
          },
          {},
        );
        setOfferItemMap(output);
        delete cloneSelectedWrapperIdList[productWrapper.id];
      }
    } else {
      if (!cloneSelectedWrapperIdList[productWrapper.id]) {
        cloneSelectedWrapperIdList[productWrapper.id] = {};
      }
      const output = Object.entries(offerItemMap).reduce(
        (acc: any, [key, value]: any) => {
          const newObj = { ...value };

          // Ensure offerNameList exists
          newObj.offerNameList = [...(value.offerNameList || [])];

          if (key === String(item.id)) {
            if (isActive) {
              // 🔵 When activating: increase activeCount and add offer name
              newObj.activeCount = (value.activeCount || 0) + 1;
            } else {
              // 🔴 When deactivating: increase deActiveCount and remove offer name if exists
              newObj.deActiveCount = (value.deActiveCount || 0) + 1;
            }

            if (!newObj.offerNameList.includes(offerName)) {
              newObj.offerNameList.push(offerName);
            }
          }

          acc[key] = newObj;
          return acc;
        },
        {},
      );

      setOfferItemMap(output);

      cloneSelectedWrapperIdList[productWrapper.id][item.id] = {
        memberId: item.id,
        wrapperId: productWrapper.id,
        name: item.name,
        img: productWrapper.img,
        memberType: "ITEM",
      };
    }

    setSelectedWrapperIdList(cloneSelectedWrapperIdList);
  };

  const handleSubmitData = handleSubmit((data) => {
    if (Object.keys(selectedWrapperIdList).length === 0) {
      setIsMembersEmpty(true);
    } else {
      let selectedProductsUpdate: any = [];
      Object.entries(selectedWrapperIdList).map(([key, item]: any) => {
        Object.values(item).map((product: any) => {
          selectedProductsUpdate.push({
            memberType: product.memberType,
            memberId: product.memberId,
            menuId: key,
          });
        });
      });
      let updatedGroupInfo = _.cloneDeep(groupInfo);

      const obj = {
        groupIndex: isEdit
          ? editableRewardId
          : groupInfo.length === 0
          ? 0
          : groupInfo.length, // keep old index if editing
        name: data.name,
        requiredPick: data.requiredPick,
        minPriceEach: null,
        maxPriceEach: null,
        members: selectedProductsUpdate,
      };

      if (isEdit) {
        const cloneUpdatedGroupInfo = _.cloneDeep(updatedGroupInfo);

        // Update existing group by matching groupIndex
        updatedGroupInfo = cloneUpdatedGroupInfo.map((g: any) =>
          g.groupIndex === editableRewardId ? obj : g,
        );
      } else {
        // Create new group
        updatedGroupInfo.push(obj);
      }

      setGroupInfo(updatedGroupInfo);
      setIsOpenGroupsAddModal(false);
      setIsEdit(false);
    }
  });
  const handleDeleteGroup = (index: any) => {
    const spliceGroupInfo = groupInfo.filter(
      (data: any, i: any) => data.groupIndex !== index,
    );
    setGroupInfo(spliceGroupInfo);
  };
  const [isEdit, setIsEdit] = useState(false);
  const [selectedWrapperIdListInitial, setSelectedWrapperIdListInitial] =
    useState<any>({});
  // Pre-populates the form and opens the modal in "Edit" mode
  const handleEditGroup = (groupToEdit: any) => {
    reset({
      name: groupToEdit.name,
      requiredPick: groupToEdit.requiredPick,
    });

    // Convert the members array back to the wrapper object format
    // const membersObject = groupToEdit.members.reduce(
    //   (acc: any, member: any) => {
    //     acc[member.memberId] = {
    //       memberId: member.memberId,
    //       // You might need to fetch the real name here if it's not in the object
    //       memberType: member.memberType,
    //     };
    //     return acc;
    //   },
    //   {},
    // );

    const output = groupToEdit.members.reduce((acc: any, member: any) => {
      const { menuId, memberId } = member;
      if (!acc[menuId]) acc[menuId] = {};
      acc[menuId][memberId] = { ...member };
      return acc;
    }, {});
    setSelectedWrapperIdList(output);
    // setSelectedWrapperIdListInitial(output);
    setEditableRewardId(groupToEdit.groupIndex);
    setIsOpenGroupsAddModal(true);
    setIsEdit(true);
  };

  const classes = useStyles();
  const theme: CustomTheme = useTheme();
  return (
    <>
      <Grid container style={{ marginBottom: "32px" }}>
        <Grid item xs={12}>
          <Button
            style={{
              textTransform: "none",
              color: theme.palette.custom.green.main,
              fontWeight: "bold",
            }}
            autoFocus
            onClick={handleOpenGroupsAddModal}
          >
            {"Add Group"}
          </Button>
        </Grid>
        <Grid container>
          <Grid item xs={12}>
            <CardCommon backgroundColor={"entity_highlight_background"}>
              <Grid container style={{ height: "40px", alignItems: "center" }}>
                <Grid item xs={6}>
                  <Typography
                    variant="body2"
                    style={{
                      fontWeight: "bold",
                      paddingLeft: "12px",
                      display: "flex",
                      justifyContent: "start",
                    }}
                  >
                    Name
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography
                    variant="body2"
                    style={{
                      fontWeight: "bold",
                      paddingRight: "96px",
                      display: "flex",
                      justifyContent: "end",
                    }}
                  >
                    Required Pick
                  </Typography>
                </Grid>
              </Grid>
            </CardCommon>
          </Grid>
        </Grid>
        {groupInfo.length > 0 &&
          groupInfo.map((item: any, index: number) => (
            <Grid container style={{ marginTop: "4px" }}>
              <Grid item xs={12}>
                <CardCommon backgroundColor={"entity_background"}>
                  <Grid
                    container
                    style={{ height: "40px", alignItems: "center" }}
                  >
                    <Grid item xs={6}>
                      <Typography
                        variant="body2"
                        style={{
                          fontWeight: "bold",
                          paddingLeft: "12px",
                          display: "flex",
                          justifyContent: "start",
                        }}
                      >
                        {item.name}
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      xs={6}
                      style={{
                        display: "flex",
                        justifyContent: "end",
                        alignItems: "center",
                      }}
                    >
                      <Typography
                        variant="body2"
                        style={{
                          fontWeight: "bold",
                          paddingRight: "12px",
                          display: "flex",
                          justifyContent: "end",
                        }}
                      >
                        {item.requiredPick}
                      </Typography>
                      <Button
                        style={{ minWidth: "32px" }}
                        onClick={() => handleEditGroup(item)}
                      >
                        <EditIcon />
                      </Button>
                      <Button
                        style={{ marginLeft: "4px", minWidth: "32px" }}
                        onClick={() => handleDeleteGroup(item.groupIndex)}
                      >
                        <DeleteIcon />
                      </Button>
                    </Grid>
                  </Grid>
                </CardCommon>
              </Grid>
            </Grid>
          ))}
        <Grid container>
          <Grid item xs={12}>
            {isMembersEmptyOrMinTwo && (
              <ValidationMessage message="At least two members are required." />
            )}
          </Grid>
        </Grid>
        <DialogCommonDefault
          open={isOpenGroupsAddModal}
          setOpen={() => setIsOpenGroupsAddModal(false)}
          isNeedFixedHeight={false}
        >
          <DialogContent>
            <Grid container>
              <Grid item xs={12}>
                <Typography variant="body2" style={{ fontWeight: "bold" }}>
                  Name
                </Typography>
                <TextfieldDefault
                  id="name"
                  name="name"
                  type="text"
                  label=""
                  style={{
                    border: `1px solid ${theme.palette.background.entity_border}`,
                  }}
                  inputRef={register({
                    required: "Name is required.",
                  })}
                />
                {errors.name ? (
                  <ValidationMessage message={errors.name.message} />
                ) : (
                  ""
                )}
              </Grid>

              <Grid item xs={12} style={{ marginTop: "12px" }}>
                <Typography variant="body2" style={{ fontWeight: "bold" }}>
                  Number of items required from this group
                </Typography>
                <Typography variant="caption" style={{ paddingTop: "12px" }}>
                  Defines how many items the customer must choose from this
                  group to qualify for the offer. (Example: choose 2 from
                  starters, 1 from mains, 1 from drinks.)
                </Typography>
                <TextfieldDefault
                  id="requiredPick"
                  name="requiredPick"
                  type="number"
                  label=""
                  style={{
                    border: `1px solid ${theme.palette.background.entity_border}`,
                  }}
                  inputRef={register({
                    required: "Required Pick is required.",
                    pattern: {
                      value: INTEGER_NUMBER_PATTERN,
                      message: "Invalid limit entered",
                    },
                    min: {
                      value: 1,
                      message: "Required Pick greater than 0",
                    },
                  })}
                />
                {errors.requiredPick ? (
                  <ValidationMessage message={errors.requiredPick.message} />
                ) : (
                  ""
                )}
              </Grid>

              <Grid item xs={12}>
                <ButtonCommon
                  style={{
                    flex: 1,
                    fontSize: 11,
                    marginRight: 4,
                    width: "100%",
                    marginTop: "12px",
                    marginBottom: "12px",
                    display: "flex",
                    justifyContent: "space-between",
                    textTransform: "none",
                  }}
                  variant="contained"
                  color={"green"}
                  onClick={handleOpenProductsAddModal}
                >
                  <Typography style={{ color: "white" }}>
                    {(() => {
                      const counts = Object.values(
                        selectedWrapperIdList,
                      ).reduce((acc: any, item: any) => {
                        return acc + Object.keys(item).length;
                      }, 0);

                      return `${counts} ${
                        counts === 1 ? "product" : "products"
                      } selected`;
                    })()}
                  </Typography>
                  <Typography style={{ color: "white" }}>
                    Set Products
                  </Typography>
                </ButtonCommon>
                {isMembersEmpty && (
                  <ValidationMessage message={"Members can not be empty"} />
                )}
              </Grid>
              {/* <Grid item xs={12}>
                <div
                  style={{
                    marginTop: "12px",
                  }}
                >
                  <div
                    style={{
                      width: "100%",
                      overflowX: "auto",
                    }}
                  >
                    <Autocomplete
                      options={[]}
                      multiple
                      size={"small"}
                      color="inherit"
                      freeSolo
                      style={{ width: "100%" }}
                      disableClearable
                      fullWidth
                      disabled
                      classes={{ root: classes.autoComplete }}
                      value={selectedProducts}
                      renderTags={(value, props) =>
                        value.map((option, index) => (
                          <Chip
                            label={option}
                            style={{ marginRight: "8px", marginTop: "4px" }}
                          />
                        ))
                      }
                      renderInput={(params) => (
                        <TextField
                          variant="outlined"
                          className={classes.textField}
                          multiline
                          label=""
                          {...params}
                          size="medium"
                        />
                      )}
                    />
                  </div>
                  {isMembersEmpty && (
                    <ValidationMessage message={"Members can not be empty"} />
                  )}
                </div>
              </Grid> */}
            </Grid>
          </DialogContent>
          <DialogActions style={{ marginRight: "16px" }}>
            <ButtonCommon
              onClick={() => setIsOpenGroupsAddModal(false)}
              style={{ width: "120px" }}
            >
              Cancel
            </ButtonCommon>
            <ButtonCommon onClick={handleSubmitData} style={{ width: "120px" }}>
              Save
            </ButtonCommon>
          </DialogActions>
        </DialogCommonDefault>
      </Grid>

      <ProductModal
        isOpen={isOpenProductsAddModal}
        setIsOpen={setIsOpenProductsAddModal}
        selectedWrapperIdList={selectedWrapperIdList}
        handleSubmitRewardsTypePoints={handleSubmitRewards}
        isEdit={false}
        rewardId={editableRewardId}
        isLoadingButton={false}
        handleSelectProduct={handleSelectProduct}
        setSelectedWrapperIdList={setSelectedWrapperIdList}
        selectedWrapperIdListInitial={selectedWrapperIdListInitial}
        offerItemMap={offerItemMap}
        selectedWrapperIdListInitialNew={selectedWrapperIdListInitialNew}
        setOfferItemMap={setOfferItemMap}
        offerItemMapInitial={offerItemMapInitial}
      />
    </>
  );
};

export default ThirdTypeGroup;
